<template>
  <v-layout row justify-space-between align-center pl-4 pt-4>
    <v-dialog
      v-model="modalMessage"
      width="95%"
      max-width="600px"
      @close="closeSuccessInvitationBlock"
      @input="(v) => v || closeSuccessInvitationBlock()"
    >
      <v-card>
        <v-card-title class="headline cyan" primary-title> Message </v-card-title>
        <v-card-text style="padding: 30px">
          <v-layout column justify-center align-center>
            <div class="message_text">You were registered to participate in auction</div>
            <div v-if="anonymousParticipationUrl" style="font-size: 18px; margin-top: 10px">
              You can access the auction through
              <a class="anonymousParticipationUrl" :href="anonymousParticipationUrl">
                the Participation Url
              </a>
            </div>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions style="padding: 12px">
          <v-spacer></v-spacer>
          <v-btn color="green lighten-3" @click="closeSuccessInvitationBlock"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
export default {
  name: 'Message',
  props: {
    auction: {
      type: Object,
    },
  },
  data() {
    return {
      modalMessage: true,
    };
  },
  computed: {
    ...mapState(['anonymousParticipationUrl']),
  },
  methods: {
    ...mapMutations(['bidderCreatedBid']),
    closeSuccessInvitationBlock() {
      this.modalMessage = false;
      this.bidderCreatedBid(false);
    },
  },
};
</script>

<style>
.message_text {
  color: lightseagreen !important;
  font-size: 20px;
}

.anonymousParticipationUrl:hover {
  text-decoration: none;
}
</style>
